
/**
 * This function will get the default langauge strings en and override them with locale specific translations
 *
 * @param language
 * @param country
 * @param translationObject
 * @returns {*}
 */
function getTranslations(language, country, translationObject) {
    let translations = translationObject[language];
    //If en_US then apply overrides from en_US on top of en strings
    if (translationObject[`${language}_${country}`]) {
        translations = Object.assign(translations, translationObject[`${language}_${country}`]);
    }
    return translations;
}

function camelToHyphen(camelCase) {
    return camelCase.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
}

export default { getTranslations, camelToHyphen }